<template>
  <v-container class="pa-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Naikintinų duomenų sąrašas') }}</h1>
    <!-- info box -->
    <v-alert class="mb-0" dense outlined type="info" color="secondary">
      {{ alertText }}
    </v-alert>
    <!-- search -->
    <admin-destroyed-object-search :loading="loading" @search="searchObject" />

    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal'),
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
        {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import AdminDestroyedObjectSearch from './AdminDestroyedObjectSearch'
import userRole from '@/mixins/userRole'
import tableParameters from '@/mixins/tableParameters'

export default {
  name: 'DestroyedObjects',
  components: {
    AdminDestroyedObjectSearch,
  },
  mixins: [userRole, tableParameters],
  data() {
    return {
      pageloading: false,
      loading: false,
      paginationloading: false,
      search: null,
      listData: [],
      searchData: {},

      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    alertText() {
      return this.$t(
        'Sąraše atvaizduojami duomenys, kurie registro duomenų bazės archyve buvo saugomi ilgiau nei 15 metų nuo išregistravimo dienos'
      )
    },
    headers() {
      return [
        {
          text: this.$t('Eil. Nr.'),
          align: 'start',
          sortable: false,
          value: 'number',
        },
        {
          text: this.$t('Įgaliojimų registro objekto (pranešimo) pavadinimas'),
          align: 'start',
          value: 'type',
        },
        {
          text: this.$t('Įgaliojimų registro objekto identifikavimo kodas (žurnalo numeris)'),
          align: 'start',
          value: 'object_id',
        },
        {
          text: this.$t('Objekto įregistravimo / priimto pranešimo data'),
          align: 'start',
          value: 'registration_date_from',
        },
        {
          text: this.$t('Objekto išregistravimo / pranešimo atmetimo data'),
          align: 'start',
          value: 'registration_date_to',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  beforeDestroy() {},
  created() {
    // this.setlistParams()
  },
  methods: {
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      if (this.searchData.btn === undefined) {
        this.loading = false
        this.pageloading = false
        this.paginationloading = false
        return
      }

      this.setSortParams()

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`object-destroyed/list`, data)
        .then((res) => {
          this.listData = res.data.objectDestroyed
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
        pageSize: pagination.itemsPerPage,
        page: pagination.page,
        route: this.$route.name,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchObject(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(searchData.btn)
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
